import axios from "axios";
import axiosInstance from "@/lib/axios";

export interface UserSubscription {
  uuid: string;
  plan_uuid: string;
  plan_name: string;
  is_active: boolean;
  starts_at: string;
  expires_at: string;
  days_left: number;
  max_devices: number;
  max_profiles: number;
  show_ads: boolean;
}

export interface UserSubscriptionResponse {
  data: UserSubscription;
  succeed: true;
  reason: string | null;
  error: string | null;
}


export async function getMySubscription(): Promise<UserSubscriptionResponse> {
  try {
    const { data } = await axiosInstance.get<UserSubscriptionResponse>(
      "/me/subscription",
      { withCredentials: true }
    );
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      throw err.response?.data;
    }
    throw err;
  }
}
